export default __webpack_public_path__ + "static/universityLogo-9ccb27b54e5bf7ddb4f1c60ae6fdd8a3.png";